import React from 'react';
import './Spinner.css'; // Import stylesheet

const LoadingSpinner = (): JSX.Element => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
